import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import snackbar, {SnackbarState} from './modules/snackbar'
import berechnung, { BerechnungState } from './modules/berechnung'
import pdfparams, { PdfParamsState } from './modules/pdfparams'
import error, { ErrorState } from './modules/error'
import ergebnis, { ErgebnisState } from './modules/ergebnis'
import search, { SearchState } from './modules/search'
import { UserState } from './modules/user'

Vue.config.devtools = true;
Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

export interface RootState {
    user: UserState,
    berechnung: BerechnungState,
    pdfparams: PdfParamsState,
    ergebnis: ErgebnisState,
    error: ErrorState,
    snackbar: SnackbarState,
    search: SearchState
}

const store = new Vuex.Store<RootState>({
    modules: {
        user,
        snackbar,
        berechnung,
        pdfparams,
        error,
        ergebnis,
        search
    },
    strict: debug
});

function addUserInfo(userInfo: Object) {
  store.commit("user/setUser", userInfo);
  return store;
}

export const storeWithUser = addUserInfo;
export default store;